/**
 * NEXORA AI - SocialNetworksStep (Refactorisé avec Design System)
 * Epic 1.3 Phase 2.2 - Onboarding Premium
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Share2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import SelectionCard, { SelectionCardGrid } from '../ui/selection-card';
import StepHeader from '../ui/step-header';
import ValidationMessage from '../ui/validation-message';

const SOCIAL_NETWORKS = [
  { id: 'facebook', label: 'Facebook', icon: '📘' },
  { id: 'instagram', label: 'Instagram', icon: '📸' },
  { id: 'twitter', label: 'Twitter / X', icon: '🐦' },
  { id: 'linkedin', label: 'LinkedIn', icon: '💼' },
  { id: 'tiktok', label: 'TikTok', icon: '🎵' },
  { id: 'youtube', label: 'YouTube', icon: '📹' }
];

export default function SocialNetworksStep({ data, onNext, onBack, onData }) {
  const { t } = useTranslation('onboarding');
  const [selected, setSelected] = useState(data.socialNetworks || []);
  const [showValidation, setShowValidation] = useState(false);

  const handleSelect = (networkId) => {
    const newSelected = selected.includes(networkId)
      ? selected.filter((id) => id !== networkId)
      : [...selected, networkId];
    setSelected(newSelected);
    onData({ socialNetworks: newSelected });
  };

  const handleNext = () => {
    setShowValidation(true);
    setTimeout(() => onNext(), 1200);
  };

  const handleSkip = () => {
    onNext();
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 sm:p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-4xl"
      >
        <StepHeader
          icon={<Share2 className="text-cyan-400" />}
          title={t('social_title')}
          subtitle={t('social_subtitle')}
        />

        <SelectionCardGrid cols={3} className="mb-8">
          {SOCIAL_NETWORKS.map((network) => (
            <SelectionCard
              key={network.id}
              id={network.id}
              selected={selected.includes(network.id)}
              onSelect={handleSelect}
              icon={network.icon}
              title={network.label}
              size="md"
            />
          ))}
        </SelectionCardGrid>

        <ValidationMessage
          show={showValidation}
          type="success"
          message={t('validation_social')}
        />

        <div className="flex justify-between items-center">
          <Button variant="ghost" onClick={onBack} className="min-h-[44px]">
            {t('back')}
          </Button>
          <div className="flex gap-3">
            <Button variant="ghost" onClick={handleSkip} className="min-h-[44px]">
              {t('skip_step')}
            </Button>
            <Button
              onClick={handleNext}
              disabled={showValidation}
              className="min-h-[44px] bg-cyan-600 hover:bg-cyan-500"
            >
              {t('continue')}
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
